import { InjectionToken } from '@angular/core';

/**
 * This `InjectionToken` should be used in a specific way to allow lazy `@NgModule`s to be lazy-loaded correctly.
 * This token is provided in an `@NgModule` that is intended to be lazy-loaded.
 * This token is provided for an `@Component` that will be the root of the new `@Component` tree.
 * - The `@NgModule` using this token should provide the `@Component` like this:
    ```ts
    @NgModule({
        declarations: [
            TheComponent
            // ... other declarations
        ],
        providers: [
            { provide: LAZY_VIEW_ENTRY_COMPONENT, useValue: TheComponent }
            // ... other providers
        ],
        entryComponents: [
            TheComponent
        ]
    })
    export class SomeModule { }
    ```
 * - The parent webpack chunk for this `@NgModule` should not have any static `import`
 *    to any code file in this `@NgModule` or below.
 */
export const LAZY_VIEW_ENTRY_COMPONENT = new InjectionToken<any>('LAZY_VIEW_ENTRY_COMPONENT');
